/**
 * The angularjs states related to the module LinkShortenerModule
 */
crmOrganizationsStates.$inject = ['$stateProvider'];
export function crmOrganizationsStates($stateProvider) {
    $stateProvider
        .state('auth.alcmeon.fuse.parameters.crm', {
            url: '/crm',
            abstract: true,
        })
        .state('auth.alcmeon.fuse.parameters.crm.organizations', {
            url: '/{crmType}/organizations?error',
            resolve: {
                organizations: ['$stateParams', 'AngularCrmOrganizationsService', function ($stateParams, AngularCrmOrganizationsService) {
                    return AngularCrmOrganizationsService.getOrganizationsList($stateParams.crmType)
                    .toPromise().then(response => response);
                }],
            },
            views: {
                'container@auth': {
                    template: '<angular-crm-organizations [organizations]="organizations"></angular-crm-organizations>',
                    controller: ['$scope', 'organizations', function ($scope, organizations) { $scope.organizations = organizations }]
                }
            }
        })
        .state('auth.alcmeon.fuse.parameters.crm.organizations.configuration', {
            url: '/:organizationId/configuration',
            resolve: {
                organization: ['$stateParams', 'CrmFactory', function ($stateParams, CrmFactory) {
                    return CrmFactory.getOrganization($stateParams.companyId, $stateParams.organizationId)
                        .then(response => response.data);
                }],
                configurationPageFreshData: ['$stateParams', 'CrmFactory', function ($stateParams, CrmFactory) {
                    return CrmFactory.getConfigurationPageFreshData($stateParams.companyId, $stateParams.organizationId)
                        .then(
                            response => response.data,
                            response => CrmFactory.handleCrmErrors(response)
                        );
                }]
            },
            views: {
                'container@auth': {
                    template: require('src/ajs-app/components/parameters/crm/crm-organizations-configuration.html'),
                    controller: 'CrmOrganizationsConfigurationController'
                }
            }
        })
}